<template>
  <generic-container
    :title="$t('inventory overview')"
    icon="boxes"
    :header_buttons="header_buttons"
    ref="generic_container"
  >
    <div class="ui people shape" ref="shape">
      <div class="sides">
        <div class="active side">
          <table
            class="ui celled very compact selectable striped table"
            ref="table"
          >
            <thead>
              <tr>
                <th>{{ $t("product") }}</th>
                <th>{{ $t("description") }}</th>
                <th>{{ $t("inputs") }}</th>
                <th>{{ $t("outputs") }}</th>
                <th>{{ $t("on hand") }}</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
        <div class="side">
          <h3 class="ui dividing header">{{ $t("inventory closures") }}</h3>
          <div class="ui relaxed selection divided horizontal list">
            <div
              class="item"
              v-for="(closure, index) in inventory_closures"
              :key="index"
              @click="show_closure(closure)"
            >
              <i class="large warehouse middle aligned icon"></i>
              <div class="content">
                <a class="header">
                  {{ $t("closure for") }}
                  {{
                    closure.closing_date
                      | formatDate(enterprise_setup.simple_date_format)
                  }}
                </a>
                <div class="description">{{ closure.comment }}</div>
                <div class="extra">
                  {{ $t("registered") }}
                  {{
                    closure.create_date
                      | formatDate(enterprise_setup.simple_date_format)
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <pre>{{ inventory_inputs }}</pre> -->
    <template v-for="(mdl, index) in product_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
        :product_in="selected_product"
      ></component>
    </template>
    <template v-for="(mdl, index) in closing_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
      ></component>
    </template>
    <template v-for="(mdl, index) in closure_modals">
      <component
        :is="mdl"
        :key="index"
        v-on:succedded="succedded"
        v-on:destroy="destroy"
        v-on:closure_updated="refresh"
        :closure_in="selected_closure"
      ></component>
    </template>
  </generic-container>
</template>

<script>
import { local_api, error_toast, enterprise_setup } from "@/utils";
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import "datatables.net";
import "datatables.net-se";
import ProductModal from "./InventoryOverviewProductModal";
import ClosingModal from "./InventoryOverviewClosingModal";
import ClosureModal from "./InventoryOverviewClosureModal";
// import InventoryInputModal from "./InventoryInputModal";

// @ is an aliass to /src
export default {
  name: "InventoryOverviewComponent",
  components: {
    GenericContainer,
  },
  filters: filters,
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  data() {
    return {
      // configure_modal: ConfigureModal,
      product_modals: [],
      closing_modals: [],
      closure_modals: [],
      header_buttons: [
        {
          icon: "refresh",
          color: "green",
          click: this.refresh,
          tooltip: this.$t("refresh"),
        },
        {
          icon: "store slash",
          color: "blue",
          click: this.closing,
          tooltip: this.$t("closing"),
        },
        {
          icon: "exchange alternate",
          color: "black",
          click: this.flip_view,
          tooltip: this.$t("flip view"),
        },
      ],
      selected_product: undefined,
      products: [],
      datatable: undefined,
      shape: undefined,
      inventory_closures: [],
      selected_closure: undefined,
    };
  },
  methods: {
    succedded() {
      this.refresh();
    },
    refresh() {
      let vm = this;
      // local_api(vm, "post", "/inventory_overview/do-get-products")
      //   .then(p => {
      //     vm.products = p;

      //     if (vm.datatable) vm.datatable.destroy();

      let dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/English.json";
      if (vm.$i18n.locale == "es")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/Spanish.json";
      else if (vm.$i18n.locale == "fr")
        dict = "//cdn.datatables.net/plug-ins/1.10.21/i18n/French.json";

      if (window.jQuery.fn.DataTable.isDataTable(vm.$refs.table)) {
        window
          .jQuery(vm.$refs.table)
          .DataTable()
          .destroy();
      }

      vm.datatable = window.jQuery(vm.$refs.table).DataTable({
        processing: false,
        serverSide: true,
        language: {
          url: dict,
        },
        ajax: {
          url:
            window.jQuery.fn.api.settings.api[
              "inventory overview products url"
            ], //"/inventory_overview/do-get-products",
          type: "post",
          beforeSend: function(request) {
            vm.$refs.generic_container.set_loading(true);
            let token = vm.$session.get("token");
            if (token) {
              request.setRequestHeader("x-access-token", token);
            }
          },
          dataSrc: function(json) {
            vm.$refs.generic_container.set_loading(false);
            if (!json.success) this.$alertify.error(json.error);
            else return json.data;
          },
        },
        columns: [
          {
            data: function(row) {
              return row.name;
            },
          },
          {
            data: function(row) {
              return row.description;
            },
          },
          {
            data: function(row) {
              return row.input_sum;
            },
          },
          {
            data: function(row) {
              return row.output_sum;
            },
          },
          {
            data: function(row) {
              return row.input_sum - row.output_sum;
            },
          },
        ],
        createdRow: function(row, data) {
          if (data.input_sum - data.output_sum < 0)
            window.jQuery(row).addClass("error");
          window.jQuery(row).click(function() {
            vm.selected_product = data;
            vm.product_modals.push(ProductModal);
          });
        },
      });

      //   })
      //   .catch(err => {
      //     error_toast(err);
      //   });

      local_api(vm, "post", "/inventory_overview/do-get-closures")
        .then((c) => {
          vm.inventory_closures = c;
        })
        .catch((err) => {
          error_toast(err);
        });
    },
    // view_product(product) {
    //   this.$router.push({
    //     name: "ProductView",
    //     query: { i: product.prd_product.uuid }
    //   });
    // },
    // view_input(input) {
    //   this.selected_input = input;
    //   this.input_modals.push(InventoryInputModal);
    // },
    destroy() {
      this.product_modals = [];
      this.closing_modals = [];
      this.selected_product = undefined;
      // this.refresh();
    },
    closing() {
      let vm = this;
      /*this.$alertify.confirm(
        this.$t("are you sure to process inventory closing?"),
        function() {
          local_api(vm, "post", "/inventory_overview/do-close")
            .then(c => {
              console.log(c);
            })
            .catch(err => {
              error_toast(err);
            });
        }
      );*/
      vm.closing_modals.push(ClosingModal);
    },
    flip_view() {
      this.shape.shape("flip right");
    },
    show_closure(closure) {
      let vm = this;
      vm.selected_closure = closure;
      vm.closure_modals.push(ClosureModal);
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.$refs.generic_container.set_loading(true);
    vm.refresh();
    vm.shape = window.jQuery(vm.$refs.shape).shape({
      onChange() {},
    });
  },
  watch: {},
};
</script>
